<script>
import Vue from 'vue'
import Card from "@/components/ui/Card.vue";
import Checkbox from "@/components/ui/Checkbox.vue";
import {getCompanySettingsList} from "@/api/company"
import TariffItemComponents from "@/views/insuranceProducts/components/ProductTariffs/indexTariff"
import PartnerList from "@/views/insuranceProducts/components/PartnerList.vue";
import TariffSetting from "@/views/insuranceProducts/components/TariffSetting.vue";
import TariffSettingFilter from "@/views/insuranceProducts/components/TariffSettingFilter.vue";
import FilterButton from "@/views/insuranceProducts/components/FilterButton.vue";
import tariffMixin from "@/views/insuranceProducts/mixins/tariffMixin";

export default Vue.extend({
  name: "Index",
  mixins: [tariffMixin],
  components: {
    FilterButton,
    TariffSettingFilter,
    TariffSetting,
    PartnerList,
    Checkbox,
    Card,
    ...TariffItemComponents,
  },
  data() {
    return {
      companies: [],
      filterParams: {
        companyIds: [],
        productIds: [],
      },
      showFilter: false,
    }
  },
  computed: {
    allSettingParams() {
      return {id: 'all', commission: 0, gap: 0, userId: this.$route.params.id ? this.$route.params.id : null, filters: this.filterParams}
    },
    appAdminDomain() {
      return process.env.VUE_APP_ADMIN_DOMAIN
    }
  },
  watch: {
    filterParams: {
      handler: function () {
        if (this.$route.params.id) {
          this.getCompanySettingsList({userId: this.$route.params.id, ...this.filterParams})
        } else {
          this.getCompanySettingsList(this.filterParams)
        }
        // if (this.filterParams.companyIds.length || this.filterParams.productIds.length) {
        // console.log(this.normalizeArrayQuery(this.$route.query))
        //
        //   const query = this.convertToArrayQuery(this.filterParams)
        //   this.$router.push({name: 'products', query: query})
        // // }
      },
      deep: true,
    }
  },
  methods: {
    getComponentByType(typeId) {
      switch (typeId) {
        case 1:
          return 'TariffOsagoItem';
        case 3:
          return 'TariffGreenCardItem'
        case 4:
          return 'TariffDgoItem'
        case 5:
          return 'TariffTourismItem'
        case 6:
          return 'TariffAutLawyerItem'
        case 8:
          return 'TariffHomeItem'
        case 9:
          return 'TariffMiniKaskoItem'
        case 10:
          return 'TariffPetsItem'
        case 12:
          return 'TariffAccidentItem'
      }
    },
    getCompanySettingsList(params = {}) {
      getCompanySettingsList(params).then(response => {
        this.companies = response.data.data
      }).catch(error => {
        if (error.response.status === 403) {
          this.$router.push({name: 'prime'})
        }
      })
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.getCompanySettingsList({userId: this.$route.params.id, ...this.filterParams})
    } else {
      this.getCompanySettingsList(this.filterParams)
    }
  }
})
</script>

<template>
  <div class="mt-4">
    <div class="position-relative">
      <div class="all-tariff-setting">
        <TariffSetting v-if="isMainPartner"
                       :item="allSettingParams"
                       @change="getCompanySettingsList(filterParams)">
          <div v-if="$route.params.id">
            Налаштування тарифів для точки продажу id: {{ $route.params.id }}
          </div>
          <div v-else>
            Налаштування тарифів для всіх точок продажу
          </div>
          <template #button>
            Налаштувати всі продукти
          </template>
        </TariffSetting>
        <FilterButton @click="showFilter = !showFilter"/>
      </div>
    </div>
    <!--        <TariffSettingFilter :visible="showFilter" v-if="companies.length || filterParams.companyId !== null || filterParams.productId !== null" v-model="filterParams" :companies="companies" />-->
    <TariffSettingFilter v-if="showFilter" v-model="filterParams" :companies="companies"/>

    <Card class="w-100 mt-4" v-for="item in companies" :key="item.id">
      <template #title>
        <div class="d-flex justify-content-between">
          <div>
            <!--                        //TODO temporary url-->
            <img v-if="item.companyLogo" :src="appAdminDomain + item.companyLogo" alt="" width="88">
            {{ item.companyName }}
          </div>
          <!--                    <div class="select-all">-->
          <!--                        <div>-->
          <!--                            &lt;!&ndash;                        @change="toggleAllActive(item, $event)"&ndash;&gt;-->
          <!--                            <Checkbox v-model="item.allActive"></Checkbox>-->
          <!--                        </div>-->
          <!--                        <div>-->
          <!--                            Усі продукти-->
          <!--                        </div>-->
          <!--                    </div>-->
        </div>
      </template>
      <div v-for="tariff in item.tariffs">
        <div class="tariff-setting">
          <TariffSetting v-if="isMainPartner && !$route.params.id" :item="tariff"
                         :hide-discount="[8, 9, 10, 12].includes(item.productTypeId)"
                         @change="getCompanySettingsList(filterParams)">
            <div v-if="$route.params.id">
              Налаштування тарифів {{ item.companyName }} для точки продажу id: {{ tariff.userId }}
            </div>
            <div v-else>
              Налаштування тарифів {{ item.companyName }} для всіх точок продажу
            </div>
            <template #button class="cursor-pointer">
              Налаштувати тариф
            </template>
          </TariffSetting>
        </div>
        <div class="row">
          <div class="col-12 mt-4">
            <!--                @update:tariff="$message('Тариф оновлено'); getTariffs()-->
            <Component :is="getComponentByType(item.productTypeId)"
                       :tariff.sync="tariff"
                       :companyName="item.companyName"
            ></Component>
          </div>
          <div class="col-12 mt-4 mr-2" v-if="!$route.params.id && isMainPartner">
            <PartnerList :items="tariff.tariffPartnersSettings" :company-name="item.companyName" :product-type-id="item.productTypeId"></PartnerList>
          </div>
        </div>
      </div>
    </Card>
  </div>
</template>

<style scoped lang="scss">
/*.select-all {
    display: flex;
    align-items: center;
    gap: 3px;
    font-family: Inter, serif;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    !* identical to box height, or 129% *!

    color: #09090B;
    !* Inside auto layout *!
    flex: none;
    order: 1;
    flex-grow: 0;

}*/
.all-tariff-setting {
  display: flex;
  gap: 16px;
  position: unset;
  top: unset;
  right: unset;
  margin-bottom: 10px;
  @media (min-width: 768px) {
    position: absolute;
    top: -70px;
    right: 0;
  }
}

.tariff-setting {
  text-align: end;
  cursor: pointer;
  font-family: 'Inter', serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  /*line-height: 18px;*/
  /* identical to box height, or 129% */
  color: #09090B;
}
</style>
